import { COMMITTEE_DOCUMENTS } from '../actions';

export default ( state = {}, action ) => {
	switch ( action.type ) {
		case COMMITTEE_DOCUMENTS:
			let total = (typeof state.total === 'undefined' || typeof action.payload.total_documents !== 'undefined'
			            ) ? action.payload.total_documents : state.total;
			return {
				documents: [
					...action.payload.documents
				], total : parseInt( total )
			};
	}
	return state;
}